export const InvoiceStatus = {
    PENDING:"معلق",
    PROCESSING:"در حال انجام",
    CANCELLED:"لغو شده",
    NEED_REVIEW:"نیازمند بازبینی",
    NEED_TO_PAY:"نیازمند پرداخت",
    COMPLETED:"تکمیل شده",
    REFUNDED:"پس داده شده",
    FAILED:"ناموفق",
    DRAFT:"پیشنویس"
}
